import { render, staticRenderFns } from "./Alumini.vue?vue&type=template&id=49cdd1a1&"
import script from "./Alumini.vue?vue&type=script&lang=js&"
export * from "./Alumini.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports